import { Component, OnInit } from '@angular/core';
import { NgProgress, NgProgressRef } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { ConfirmActionComponent } from 'src/app/components/dialog/confirm/confirm-action/confirm-action.component';
import { ListParams, OrganizationList, PaginationInput, PaginationPageEvent, Res } from 'src/app/models';
import { ApiOrganizationsService, DialogModalService, LanguageService, NotificationService, PermissionService } from 'src/app/services';
import { PaginationService } from 'src/app/services/pagination.service';

@Component({
  selector: 'app-organization-list',
  templateUrl: './organization-list.component.html',
  styleUrls: ['./organization-list.component.css']
})
export class OrganizationListComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  organizations: OrganizationList[] = [];
  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private apiOrganizations: ApiOrganizationsService,
    private dialogModal: DialogModalService,
    private notification: NotificationService,
    public permissionAccess: PermissionService,
    private paginationService: PaginationService
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');

    this.getList();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.subscriptions.add(
      this.paginationService.listenerPaginationListData().subscribe(val => {

        if (val) {

          this.pageEvent(val);

        }
      })
    );
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  getList(): void {

    this.progressRef.start();
    this.loading = true;
    this.organizations = [];

    this.setListParams();

    this.apiOrganizations.getList(this.listParams).subscribe((response: Res) => { console.log('[RESPONSE] getList organizations: ', response);
    
      
      if(response != null){

        if(response.result != null){
        
          this.organizations = response.result.list;

          this.paginationInput = {
            count:          response.result.count,
            numberOfPages:  response.result.numberOfPages,
            currentPage:    this.listParams.pageNumber,
            size:           this.listParams.countOnPage
          }
        }
      }

      this.paginationService.setPaginationData(this.paginationInput);

      this.progressRef.complete();
      this.loading = false;
    },
    error => { 
      this.progressRef.complete();
      this.loading = false;
    });
  }

  onConfirm(ids: string[]) {

    let message = 'Вы действительно хотите удалить?';

    this.dialogModal.open(message, ConfirmActionComponent, '', 'confirmAction-window').then(
      (result) => {

        if (result) {

          this.onDelete(ids);
        }
      },
      () => { console.log('Rejected!'); }
    );

  }

  /**
  * 
  * @param ids 
  */
   onDelete(ids: string[]): void {

    this.progressRef.start();

    this.subscriptions.add(
      this.apiOrganizations.delete({ id: ids }).subscribe(response => {

        if (response != null) {

          this.getList();

          this.notification.show('success', 'Данные успешно удалены!');
        }

        this.progressRef.complete();
      })
    );
  }

  /**
   * 
   */
  // deleteSelected(): void {

  //   let ids = [...new Set(this.organizations.filter(val => val.checked).map(({ id }) => id))];
  //   this.onDelete(ids);
  // }


  /**
   * 
   */
  setListParams(): void {

    this.listParams = {
      filter: {
        user_id: ''
      },
      object: 'organization',
      pageNumber:  (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 1 : this.paginationOutput.pageNumber,
      countOnPage: (!this.paginationOutput || this.paginationOutput == undefined || this.paginationOutput == null) ? 10 : this.paginationOutput.pageSize
    }
  }

  
  /**
   * 
   * @param event 
   */
  pageEvent(event: PaginationPageEvent): void {
    
    this.paginationOutput = event;
    this.getList();
  }

  getRowNumber(index: number): number {
    const page = this.paginationOutput?.pageNumber || 1;
    const pageSize = this.paginationOutput?.pageSize || 10;
    return (page - 1) * pageSize + index + 1;
  }

}
